import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, MenuItem } from "@mui/material";
import { SectionProps, BUSINESS_FORM_KEYS, VAT_STATUS_KEYS } from "./profileShared";

/** DAC7 / BTW intake — data collection only; the FOD XML report is a
 *  separate later task. Drives platform-fee invoicing (Peppol vs pdf). */
export default function BillingSection({ profile, onChange }: SectionProps) {
  const { t } = useTranslation();
  const setField = (key: string, v: string) => onChange({ ...profile, [key]: v });
  return (
    <Stack spacing={2.5}>
      <TextField select label={t("vetting.businessForm")} value={profile.businessForm || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("businessForm", e.target.value)} sx={{ maxWidth: 340 }}>
        <MenuItem value="">{t("vetting.professionNone")}</MenuItem>
        {BUSINESS_FORM_KEYS.map((k) => <MenuItem key={k} value={k}>{t(`vetting.businessForms.${k}`)}</MenuItem>)}
      </TextField>
      <TextField select label={t("vetting.vatStatus")} value={profile.vatStatus || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("vatStatus", e.target.value)} sx={{ maxWidth: 420 }}>
        <MenuItem value="">{t("vetting.professionNone")}</MenuItem>
        {VAT_STATUS_KEYS.map((k) => <MenuItem key={k} value={k}>{t(`vetting.vatStatuses.${k}`)}</MenuItem>)}
      </TextField>
      {profile.vatStatus && profile.vatStatus !== "none" && (
        <TextField label={t("vetting.vatNumber")} value={profile.vatNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("vatNumber", e.target.value)} sx={{ maxWidth: 340 }} />
      )}
      {profile.businessForm === "company" && (
        <TextField label={t("vetting.kbo")} value={profile.kboNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("kboNumber", e.target.value)} sx={{ maxWidth: 340 }} />
      )}
      {profile.businessForm === "natural_person" && (
        <>
          <TextField label={t("vetting.tin")} value={profile.tin} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("tin", e.target.value)} helperText={t("vetting.tinHint")} sx={{ maxWidth: 340 }} />
          <TextField label={t("vetting.birthDate")} type="date" value={profile.birthDate} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("birthDate", e.target.value)} InputLabelProps={{ shrink: true }} sx={{ maxWidth: 340 }} />
        </>
      )}
      {/* Hoofdadres — wettelijk verplicht in het jaarlijkse DAC7-rapport. */}
      <TextField label={t("vetting.addressStreet")} required value={profile.addressStreet} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("addressStreet", e.target.value)} helperText={t("vetting.addressHint")} sx={{ maxWidth: 420 }} />
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField label={t("vetting.addressPostalCode")} required value={profile.addressPostalCode} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("addressPostalCode", e.target.value)} sx={{ maxWidth: 140 }} />
        <TextField label={t("vetting.addressCity")} required value={profile.addressCity} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("addressCity", e.target.value)} sx={{ maxWidth: 260 }} />
      </Stack>
    </Stack>
  );
}
